import { Component, ElementRef, OnInit } from '@angular/core';
import { MaterializeAction } from 'angular2-materialize';
import { Router } from '@angular/router';

import { NotificationsService } from './notifications.service';
import { Notification } from './notifications.model';
import { SharedUtils } from '../utils';

declare var Materialize: any;


@Component({
    selector: 'notifications',
    template:`
    <div class="notifications" style="position:fixed">    
        <div (click)="hide(note, note.type != 'exception')" class="{{ note.type }}"
                *ngFor="let note of _notes">   
            {{ note.message }}
            <a materialize="tooltip" class="notification-close tooltipped" 
                data-position="bottom" data-delay="50" data-tooltip="close" [hidden]="note.type!='exception'" 
                (click)="hide(note)">

                <i class="material-icons" >close</i>
            </a>
        </div>
    </div>
    `
})
export class NotificationComponent implements OnInit {
    
    private element: JQuery;    
    private _notes: Notification[];

    constructor(
        private _notifications: NotificationsService,
        private _router: Router,
        private _el: ElementRef
    ) {
        this.element = $(_el.nativeElement);        
        this._notes = new Array<Notification>();

        _notifications.noteAdded.subscribe(note => {
            this._notes.push(note);
            if(note.type=='exception')
            {
                if (note.description){
                    note.message = note.description + '. ' + note.message;    
                }else{
                    note.message="Apologies, something went wrong, please mention the following error/code when requesting help: "+ note.message;
                }
            }
            else if (note.type === 'warn'){
                if (note.description){
                    note.message = note.description + '. ' + note.message;    
                }else{
                    note.message= (note.includePremessage ? "Mmmh... something does not seem right, please mention the following error/code when requesting help: " : "") + note.message;
                }
            }else
            {
                setTimeout(() => { this.hide.bind(this)(note) }, 5000);
            }
        });
        _router.events.subscribe(ev => {
           if(this._notes && this._notes.findIndex(note=>note.type=='exception')>=0)
           {
               var exNotes= this._notes.filter(note=>note.type=='exception');
               if(exNotes)
               exNotes.forEach(note=>this.hide(note));
           }
        });
    }

    ngOnInit(): void {
        //this.element.appendTo('body');
        this.initMaterial();
    }
    ngAfterViewInit() {
        $('.tooltipped').tooltip({ delay: 50 });
        SharedUtils.RemoveTooltipIfNeeded();
        $('.collapsible').collapsible();
        
      }
      initMaterial() {
        Materialize.updateTextFields();
      }
    public hide(note, notAnException:Boolean = true) {

        if (!notAnException){
            return;
        }

        let index = this._notes.indexOf(note);

        if (index >= 0) {
            this._notes.splice(index, 1);
        }
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/shared/helper-components/notifications.component.ts